import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=b45a4b2e&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=b45a4b2e&prod&scoped=true&lang=css&"
import style1 from "./banner.vue?vue&type=style&index=1&id=b45a4b2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a4b2e",
  null
  
)

export default component.exports